/**
 * Created by jayed.talukder on 9/13/2018.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { FieldSection } from '@shared/models/field-section';
import { PagedResponse } from '@shared/models/paged-response-model';
import { TransactionConfig } from '../transaction.config';
import {EntitySetting} from '../../models/entity-setting.model';
import {PaymentStreamSetting} from '../../models/payment-stream-setting.model';

@Injectable()
export class TransactionService {
  constructor(private httpClient: HttpClient) {}

  getAllPayingEntities(): Observable<any> {
    return this.httpClient.get<EntitySetting[]>(TransactionConfig.getAllPayingEntities());
  }

  getAllReceivingEntities(): Observable<any> {
    return this.httpClient.get<EntitySetting[]>(TransactionConfig.getAllReceivingEntities());
  }

  getAllStreams(): Observable<any> {
    return this.httpClient.get<PaymentStreamSetting[]>(TransactionConfig.getAllStreams());
  }

  getTransactionFieldSections():  Observable<FieldSection[]> {
    return this.httpClient.get<FieldSection[]>(TransactionConfig.getTransactionFieldSectionApi());
  }

  getReceivingEntities(payingEntityId: string): Observable<any> {
    return this.httpClient.get<EntitySetting[]>(TransactionConfig.getReceivingEntities(payingEntityId));
  }

  getStreams(payingEntityId: string, receivingEntityId: string): Observable<any> {
    return this.httpClient.get<PaymentStreamSetting[]>(TransactionConfig.getStreams(payingEntityId, receivingEntityId));
  }

  getTransactions(pageNo: number, pageSize: number):  Observable<PagedResponse> {
    return this.httpClient.get<PagedResponse>(TransactionConfig.getTransactionsApi(pageNo, pageSize));
  }
}
